// extracted by mini-css-extract-plugin
export var rateTable = "_60-0";